export const routes = (prefix=`reports`, pre=`patients`) => [
    {
        name: `${prefix}.${pre}.gate-pass-report.index`,
        path: `/${prefix}/${pre}/gate-pass-report`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.${pre}.gate-pass-report.index`,
                PageDescription: "Patient Reports: Gate Pass report",
            },
        },
    },
    {
        name: `${prefix}.${pre}.print.gate-pass-report.index`,
        path: `/${prefix}/${pre}/gate-pass-report/print`,
        component: () => import('./prints/GatePassReport.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.${pre}.gate-pass-report.index`,
                PageDescription: "Patient Reports: Gate Pass report",
            },
            print: true,
        },
    },
];
